module.exports = __webpack_public_path__ + "static/media/robust.e0f12d17.png";